import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'

import styles from './styles.module.scss'

export interface MarketingQuestionAndAnswerProps {
  question: React.ReactNode
  answer: React.ReactNode
}

const MarketingQuestionAndAnswer = ({ question, answer }: MarketingQuestionAndAnswerProps) => {
  const [getClassName, makeTestId] = useNameFormatter('MarketingQuestionAndAnswer')

  return (
    <div className={styles[getClassName('')]}>
      <div
        className={styles[getClassName('question')]}
        data-testid={makeTestId('question')}
      >
        {question}
      </div>
      <div
        className={styles[getClassName('answer')]}
        data-testid={makeTestId('answer')}
      >
        {answer}
      </div>
    </div>
  )
}

export default MarketingQuestionAndAnswer
